/*
 * Ryan O'Dowd
 * 2025-05-22
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  useHeaderHeight,
  useSetHeaderHeight,
} from './headerHeightContext';
import useBackButton from './useBackButton';
import useFetchInitialData from './useFetchInitialData';
import useGetPhotoUrl from './useGetPhotoUrl';
import useGetVersesForPassages from './useGetVersesForPassages';
import useGetWrinkles from './useGetWrinkles';
import useGetWrinklesForVerseApiId from './useGetWrinklesForVerseApiId';
import useI18n from './useI18n';
import useIsAdmin from './useIsAdmin';
import useLocationState from './useLocationState';
import useNavigation from './useNavigation';
import useOnNotificationPress from './useOnNotificationPress';
import usePassageApiNotationToParts from './usePassageApiNotationToParts';
import usePreferredTranslation from './usePreferredTranslation';
import useRequestNotificationPermission from './useRequestNotificationPermission';
import useSelectVerses from './useSelectVerses';
import useStyles from './useStyles';
import useTheme from './useTheme';
import useTimeRemaining from './useTimeRemaining';
import useTypedDispatch from './useTypedDispatch';
import useTypedSelector from './useTypedSelector';

export default {
  useBackButton,
  useFetchInitialData,
  useGetPhotoUrl,
  useGetVersesForPassages,
  useGetWrinkles,
  useGetWrinklesForVerseApiId,
  useHeaderHeight,
  useI18n,
  useIsAdmin,
  useLocationState,
  useNavigation,
  useOnNotificationPress,
  usePassageApiNotationToParts,
  usePreferredTranslation,
  useRequestNotificationPermission,
  useSelectVerses,
  useSetHeaderHeight,
  useStyles,
  useTheme,
  useTimeRemaining,
  useTypedDispatch,
  useTypedSelector,
};
